// extracted by mini-css-extract-plugin
export default {"wrapper":"keypadList_wrapper__+3ifz","slider":"keypadList_slider__R2IiV","selected":"keypadList_selected__shz0k"};